import HttpService from '@/services/HttpService';
import { OnroerendErfgoedDto } from '@/domain/interface/geometrie/OnroerendErfgoedDto';

export default class GeometrieService {
  constructor(private readonly http: HttpService) {}

  public async getOnroerendErfgoedInformation(vbrGebouweenheidId: string): Promise<OnroerendErfgoedDto> {
    return await this.http.get<OnroerendErfgoedDto>('/geometrie-algemeen/onroerend-erfgoed/' + vbrGebouweenheidId);
  }
}
